export default {
  transactionProduct: state => state.transactionProduct,
  transactionPayment: state => state.transactionPayment,
  transactionTypes: state => state.transactionTypes,
  transactionHistory: state => state.transactionHistory
}